/* eslint-disable @typescript-eslint/ban-types */
import { objPathToTitle } from '@/editor-map/title';
import { ComponentMap, I8FormOptions } from '@/editor-map/types';
import {
  fromFormModel as i8FromFormModel,
  toFormModel as i8ToFormModel,
} from 'i8-ui';
import { countriesIso3166 } from '@/util';

const editorType = 'austrac.ifti-dra.Address';
const title = objPathToTitle;

const defaultFormMode = {
  addr: '',
  suburb: '',
  state: '',
  postcode: '',
  country: '',
};

export function toFormSchema(data: object, readonly = false): object {
  const countryOptions = countriesIso3166.reduce((options, country) => {
    options[country] = { label: country };
    return options;
  }, {} as I8FormOptions);
  return {
    elements: {
      addr: {
        type: 'text',
        label: 'Address',
        placeholder: 'Empty value',
        maxLength: 140,
        readonly,
      },
      suburb: {
        type: 'text',
        label: 'Suburb',
        placeholder: 'Empty value',
        maxLength: 35,
        readonly,
      },
      state: {
        type: 'text',
        label: 'State',
        placeholder: 'Empty value',
        maxLength: 35,
        readonly,
      },
      postcode: {
        type: 'text',
        label: 'Postcode',
        placeholder: 'Empty value',
        maxLength: 15,
        readonly,
      },
      country: {
        type: 'select',
        label: 'Country',
        options: countryOptions,
        readonly,
      },
    },
  };
}

export function fromFormModel(
  formModel: object,
  sourceData: object = {},
): object {
  const dataFromModel = i8FromFormModel(formModel, sourceData);
  return dataFromModel;
}

export function toFormModel(data: object): object {
  const model = Object.assign(defaultFormMode, data);

  // users shouldn't be able to edit id fields
  const omitIdProps = true;
  return i8ToFormModel(model, omitIdProps);
}

const componentMap: ComponentMap = {
  [editorType]: {
    title,
    toFormModel,
    fromFormModel,
    toFormSchema,
  },
};

export { componentMap };
export default componentMap;
